"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateJobPreferenceSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../shared");
const candidate_enum_1 = require("./candidate.enum");
exports.CandidateJobPreferenceSchema = zod_1.default.object({
    id: shared_1.UUIDSchema,
    candidateId: shared_1.UUIDSchema,
    desiredAnnualSalary: zod_1.default.number().int().nullable(),
    isOpenToAnyIndustry: zod_1.default.boolean(),
    isOpenToAnyLocation: zod_1.default.boolean(),
    jobSearchStatus: candidate_enum_1.JobSearchStatusEnum,
    relocationPreference: candidate_enum_1.RelocationPreferenceEnum,
    createdAt: shared_1.ISODateTimeSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
